module.exports = __webpack_public_path__ + "static/media/btn_play.a2341277.svg";